import {
	alwaysRefetchApiQueryOptions,
	isBusinessOwner,
	isSandboxEnvironment,
	REQUIRED_ONBOARDING_TASKS,
	resolveOnboardingCompletion,
} from 'BreetHelpers';
import {
	selectTargetEnvironment,
	useAppSelector,
	useGetDeveloperIntegrationQuery,
	useGetKybDetailsQuery,
	useGetTransactionsEditServicesQuery,
	useGetUserPreferenceQuery,
	useGetUserQuery,
} from 'BreetRedux';
import { useEffect, useState } from 'react';

export { REQUIRED_ONBOARDING_TASKS };

export const useOnboardingTodoListApi = () => {
	const { data: userData, isFetching: userDataFetching } = useGetUserQuery(undefined, alwaysRefetchApiQueryOptions);
	const { data: userPreferenceData, isFetching: userPreferenceFetching } = useGetUserPreferenceQuery(undefined, {
		...alwaysRefetchApiQueryOptions,
		skip: userData?.data?.businessRole !== 'owner',
	});

	const targetEnvironment = useAppSelector(selectTargetEnvironment);

	const isOnboardingOwner = !!userData?.data && isBusinessOwner(userData.data) && !isSandboxEnvironment(targetEnvironment);

	const isKybCompleted = !!userData?.data?.approvedForLive;

	const { data: kybFormData, isFetching: kybFormFetching } = useGetKybDetailsQuery(undefined, {
		...alwaysRefetchApiQueryOptions,
		skip: userData?.data?.businessRole !== 'owner' || isKybCompleted,
	});
	const { data: developerIntegrationData, isFetching: developerIntegrationFetching } = useGetDeveloperIntegrationQuery();
	const { isFetching: withdrawalHistoryFetching, data: withdrawalHistoryData } = useGetTransactionsEditServicesQuery(
		{ page: 1, size: 1, defaultParams: '' },
		alwaysRefetchApiQueryOptions
	);

	const isLoading =
		userPreferenceFetching || withdrawalHistoryFetching || kybFormFetching || developerIntegrationFetching || userDataFetching;

	const [isOnboardingReady, setIsOnboardingReady] = useState(false);
	useEffect(() => {
		if (!isLoading) setIsOnboardingReady(true);
	}, [isLoading]);

	const isMFAAuthentication =
		(userPreferenceData?.data?.usedRecoveryCodesCount ?? 0) + (userPreferenceData?.data?.unusedRecoveryCodesCount ?? 0) > 0 ||
		!!userPreferenceData?.data?.is2FAActive ||
		!!userPreferenceData?.data?.isAuthenticator2FaActive;

	const isFirstTransaction = !!withdrawalHistoryData?.data?.length;

	const kybStatus = kybFormData?.data?.status;

	const kybRejectionReason = kybStatus === 'rejected' ? (kybFormData?.data?.reason ?? 'Contact support.') : undefined;

	const { isFirstProductionApiKey, isProductionWebhookUrl, requiredCompletedCount, isOnboardingComplete } =
		resolveOnboardingCompletion(userData?.data, developerIntegrationData?.data);

	const requiredProgressPercentage = Math.round((requiredCompletedCount / REQUIRED_ONBOARDING_TASKS) * 100);

	return {
		kybStatus,
		kybRejectionReason,
		isFirstProductionApiKey,
		isLoading,
		isMFAAuthentication,
		isFirstTransaction,
		isProductionWebhookUrl,
		requiredCompletedCount,
		requiredProgressPercentage,
		isOnboardingComplete,
		isKybCompleted,
		isOnboardingOwner,
		isOnboardingReady,
	};
};
